<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
  @if (showAvatar && user?.avatar) {
    <img class="h-7 w-7 rounded-full" [src]="user.avatar" alt="" />
  } @else {
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
  }
</button>

<mat-menu [xPosition]="'before'" class="user-menu" #userActions="matMenu">
  <!--
    A plain div, not a `mat-menu-item`. It used to be one, which made the
    account line a button: it took focus, highlighted on hover and swallowed
    clicks while doing nothing. A heading is not a control.
  -->
  <div class="user-menu-account">
    @if (showAvatar && user?.avatar) {
      <img class="user-menu-avatar" [src]="user.avatar" alt="" />
    } @else {
      <mat-icon
        class="user-menu-avatar-icon"
        [svgIcon]="'heroicons_outline:user-circle'"
      ></mat-icon>
    }
    <span class="user-menu-identity">
      <!--
        Only shown when it is a real profile name. `AuthService` falls back to the
        email's local part, so otherwise this would repeat the line below it.
      -->
      @if (displayName) {
        <span class="user-menu-name">{{ displayName }}</span>
      }
      <span class="user-menu-email">{{ user?.email }}</span>
    </span>
  </div>

  <a mat-menu-item [routerLink]="['/settings']">
    <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
    <span>Settings</span>
  </a>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>
